import MemberActiveMemberships from "./membership-view";
import { Card } from "@/components/ui/card";
import MemberMembershipFacilities from "./facilities-settings";

const MembershipPlanAndFacilities = () => {
  return (
    <div className="flex flex-col gap-2">
      <Card className=" w-[100%] sxl:w-[100%]  p-4 border-t-0  rounded-none rounded-bl-md rounded-br-md">
        <MemberActiveMemberships />
      </Card>
      <Card className=" w-[100%] sxl:w-[100%] p-4 border">
        <MemberMembershipFacilities />
      </Card>
    </div>
  );
};

export default MembershipPlanAndFacilities;
